import maplibregl from "maplibre-gl";

// Shared basemap style for every map (app, public, static images). Protomaps
// hosted "white" style; see TODO.md for the planned self-hosted PMTiles move.
export const BASEMAP_STYLE =
  "https://api.protomaps.com/styles/v4/white/en.json?key=ef1a299adbab7ebd";

export const generateMapLibreStaticImage = async (
  latitude: number,
  longitude: number,
  options: {
    width?: number;
    height?: number;
    zoom?: number;
    bearing?: number;
    style?: string;
  } = {},
): Promise<string> => {
  const {
    width = 800,
    height = 500,
    zoom = 11,
    bearing = 0,
    style = BASEMAP_STYLE,
  } = options;

  const container = document.createElement("div");
  container.style.width = `${width}px`;
  container.style.height = `${height}px`;
  container.style.position = "absolute";
  container.style.top = "-9999px";
  document.body.appendChild(container);

  const map = new maplibregl.Map({
    container,
    style,
    center: [longitude, latitude],
    zoom,
    bearing,
    interactive: false,
    preserveDrawingBuffer: true, // Important for screenshot
  });

  // Wait for map to load
  await new Promise((resolve) => map.on("load", resolve));

  // Wait a bit for tiles to load
  await new Promise((resolve) => setTimeout(resolve, 1000));

  // Capture as data URL
  const canvas = map.getCanvas();
  const dataUrl = canvas.toDataURL("image/png");

  // Cleanup
  map.remove();
  document.body.removeChild(container);

  return dataUrl;
};
